import {
  BANNER_SLIDES,
  SHOWCASE_CARDS,
  PROMOS,
  TOURNAMENT_PROMOS,
  PROMO_CATEGORIES,
  PROMO_PAGE_FILTERS,
  CASINO_CATEGORIES,
} from '../data/homeData';
import { CASINO_SLIDES, casinoTabsForLobby } from '../data/casinoData';

const PROMO_TR = {
  'world-cup': {
    caption: 'Oyuna daha yakın',
    title: '2026 Dünya Kupası\'na<br>7 000 000 TL + 150 000 FS',
    detailTitle: 'VurgunBet\'te 7.000.000 TL + 150.000 FS',
    detailSubtitle: 'FIFA Dünya Kupası 2026!',
    terms: [
      'Promosyonlara katılın, spor bahisleri yapın, casino oyunları oynayın ve bonus kazanın! Bonus alma koşulları promosyon başlangıç gününde "Promosyonlar" bölümünde yayınlanır.',
      '"Büyük Oyun" promosyonunun maksimum bonus tutarı 3.000.000 TL\'dir. Promosyon süresi: 11 Haziran 2026 – 19 Temmuz 2026.',
      'Toplam bonus havuzu 2.000.000 TL + 90.000 bedava dönüş olan casino turnuvaları. Süre: 8 Haziran 2026 – 19 Temmuz 2026.',
      '"Final Yolculuğu" promosyonunun toplam bonus fonu 1.400.000 TL! Süre: 11 Haziran 2026 – 19 Temmuz 2026.',
      '"Zaferler Dünya Kupası" promosyonunun toplam bonus fonu 600.000 TL + 60.000 bedava dönüş. Süre: 8 Haziran 2026 – 19 Temmuz 2026.',
    ],
  },
  welcome: {
    caption: 'HOŞ GELDİN BONUSU',
    title: '100 TL\'ye kadar<br>bedava bahis + 300 FS',
    sub: 'Tarzınızla oynayın!',
    detailTitle: '100 TL\'ye kadar bedava bahis + 300 FS',
    landingTitle: '100 TL + 300 FS',
    detailSubtitle: 'Tarzınızla oynayın!',
    terms: [
      'Teklif, kayıt olan ve ilk para yatırma işlemini yapan yeni müşteriler için geçerlidir.',
      'Bedava bahis, nitelikli yatırım tamamlandıktan sonra hesaba yüklenir.',
      'Bedava dönüşler, yüklemeden sonra 7 gün boyunca seçili slot oyunlarında kullanılabilir.',
      'Bedava bahis için minimum oran ve çevrim şartları geçerlidir.',
    ],
  },
  predictions: {
    caption: 'FİNAL YOLCULUĞU',
    title: '2026 Dünya Kupası<br>doğru tahminlerine<br>250 000 TL',
    timer: '8 saat kaldı',
    detailTitle: '2026 Dünya Kupası doğru tahminlerine 250 000 TL',
    detailSubtitle: 'Tahminlerinizi yapın ve ödül havuzundan payınızı kazanın!',
    terms: [
      'Tahminler promosyon sayfasında belirtilen son tarihten önce gönderilmelidir.',
      'Her müşteri tur başına yalnızca bir tahmin seti gönderebilir.',
      'Ödüller en yüksek doğru sonuç sayısına sahip müşteriler arasında paylaştırılır.',
      'Kazananlar turun son maçından sonra 72 saat içinde bilgilendirilir.',
    ],
  },
  oplati: {
    caption: 'PAPARA CASHBACK',
    title: 'Her yatırımda<br>%5 cashback',
    detailTitle: 'Papara ile her yatırımda %5 cashback',
    detailSubtitle: 'Hesabınızı yükleyin, cashback otomatik gelsin!',
    terms: [
      'Cashback Papara ödeme sistemi üzerinden yapılan yatırımlara uygulanır.',
      'Nitelikli her yatırımın %5\'i ana hesaba iade edilir.',
      'Cashback, yatırım onaylandıktan sonra 24 saat içinde yüklenir.',
      'Minimum yatırım tutarı ve günlük maksimum cashback uygulanabilir.',
    ],
  },
  'live-cashback': {
    caption: 'Canlı casino cashback',
    title: 'Canlı casino\'da<br>%7\'ye kadar<br>cashback kazanın',
    detailTitle: 'Canlı casino\'da %7\'ye kadar cashback',
    detailSubtitle: 'Canlı casino aktivitenizde günlük cashback!',
    terms: [
      'Cashback, gün içinde canlı casino oyunlarındaki net kayıplar üzerinden hesaplanır.',
      'Maksimum cashback yüzdesi aktivite seviyenize bağlıdır.',
      'Cashback ertesi gün UTC+3 saat 12:00\'den önce yüklenir.',
      'Yalnızca katılımcı canlı casino masalarındaki gerçek paralı bahisler geçerlidir.',
    ],
  },
  vip: {
    caption: 'VIP CASHBACK',
    title: 'Her hafta<br>%25\'e kadar<br>cashback!',
    detailTitle: 'Her hafta %25\'e kadar cashback!',
    detailSubtitle: 'Ayrıcalıklardan yararlanın, her hafta cashback kazanın!',
    terms: [
      'VIP cashback, gerekli VIP statüs seviyesine ulaşan müşterilere sunulur.',
      'Cashback yüzdesi VIP seviyenize ve haftalık aktivitenize bağlıdır.',
      'Cashback her Pazartesi önceki hafta için yüklenir.',
      'VIP statüsü ve cashback koşulları VurgunBet tarafından değiştirilebilir.',
    ],
  },
};

const TOURNAMENT_TR = {
  'legendary-race': {
    caption: 'Turnuva',
    name: 'Efsanevi Yarış',
    detailSubtitle: 'Efsanevi Yarış turnuvası',
    daysLeft: '6 gün',
    terms: [
      'Turnuva, promosyon sayfasında belirtilen süre boyunca devam eder.',
      'Puanlar katılımcı slot oyunlarındaki nitelikli bahisler için verilir.',
      'Ödül havuzu liderlik tablosundaki en üst sıradaki katılımcılar arasında paylaştırılır.',
      'Bedava dönüş ödülleri turnuva bitiminden sonra 48 saat içinde yüklenir.',
    ],
  },
  'roulette-magic': {
    caption: 'Turnuva',
    name: 'Rulet Sihri',
    detailSubtitle: 'Rulet Sihri turnuvası',
    daysLeft: '6 gün',
    terms: [
      'Turnuva canlı casino\'daki seçili rulet masalarına uygulanır.',
      'Puanlar nitelikli gerçek paralı bahisler üzerinden hesaplanır.',
      'Liderlik tablosu turnuva süresince anlık güncellenir.',
      'Ödüller nihai tablo onaylandıktan sonra 72 saat içinde ödenir.',
    ],
  },
  'lucky-plane': {
    caption: 'Turnuva',
    name: 'Şanslı Uçak',
    detailSubtitle: 'Şanslı Uçak turnuvası',
    daysLeft: '6 gün',
    terms: [
      'Turnuva seçili hızlı oyunlarda düzenlenir.',
      'Puanlar turnuva süresince nitelikli bahisler için verilir.',
      'Ödül havuzu en üst sıradaki katılımcılar arasında paylaştırılır.',
      'Kazananlar turnuva bitiminden sonra 72 saat içinde bilgilendirilir.',
    ],
  },
  mundial: {
    caption: 'Turnuva',
    name: 'Zaferler Dünya Kupası',
    detailSubtitle: 'VurgunBet\'te Zaferler Dünya Kupası turnuvası!',
    daysLeft: '6 gün',
    terms: [
      'Katılım tüm kayıtlı VurgunBet müşterilerine açıktır.',
      'Puanlar Dünya Kupası 2026 etkinliklerindeki nitelikli bahislerle kazanılır.',
      'Liderlik tablosu turnuva süresince anlık güncellenir.',
      'Nakit ödüller ana hesaba; FS seçili slotlara yüklenir.',
    ],
  },
};

const BANNER_TR = {
  'welcome-landing': { title: '100 TL + 300 FS\'ye kadar<br>hoş geldin bonusu', sub: 'Tüm yeni üyeler için!', cta: 'Kayıt ol' },
  promos: { title: 'Sıcak Cuma', sub: 'Yatırım bonusu + üç slot oyunundan birinde bedava dönüş!', cta: 'Bonusu al' },
  TR_CRM_ACT_World_Cup_2026: { title: '7 000 000 TL<br> + 150 000 FS', sub: 'VurgunBet ile oyuna daha yakın!', cta: 'Detaylar' },
  TR_Tournament_Legendary_Race: { title: '300 000 TL <br> + 15 000 FS', sub: 'VurgunBet\'te Dünyalar Savaşı turnuvasında!', cta: 'Katıl' },
  TR_Tournament_Mundial: { title: '100 000 TL <br> + 10 000 FS', sub: 'VurgunBet\'te Zaferler Dünya Kupası turnuvasında!', cta: 'Katıl' },
  TR_Tournament_Roulette_Magic: { title: '20 000 TL<br/>canlı casino\'da', sub: 'VurgunBet\'te Kupa Oyunu turnuvasında!', cta: 'Katıl' },
  TR_Live_Casino_Cashback: { title: 'Canlı Casino\'da<br/>Cashback', sub: 'Günlük %7\'ye kadar!', cta: 'Al' },
  TR_VIP_Cashback_25: { title: 'VIP CASHBACK<br/>%25\'e kadar', sub: 'Ayrıcalıklardan yararlanın, her hafta cashback kazanın!', cta: 'Detaylar' },
  casino: { title: 'Andrea Pirlo<br/>VurgunBet\'e katıldı', sub: 'Zafer ruhunu hissedin!', cta: 'Oyna' },
  TR_Papara_Cashback_5: { title: 'Cashback %5', sub: 'Papara ile her hesap yüklemesinde!', cta: 'Hesabı yükle' },
};

const CASINO_SLIDE_TR = {
  0: { title: "Cat's Blessing", sub: 'Tılsım dünyasını keşfedin', cta: 'Oyna' },
  1: { title: '300 000 TL + 15 000 FS', sub: 'Efsanevi Yarış turnuvasında', cta: 'Katıl' },
  2: { title: 'PETER & SONS Hits', sub: 'İstediğinizden fazlası', cta: 'Oyna' },
  3: { title: 'Slattors Battle - Orcs vs Elves', sub: 'Kadim klanların savaşı', cta: 'Oyna' },
  4: { title: 'Donny Dough', sub: 'Donny\'nin para şovu', cta: 'Oyna' },
  5: { title: 'Cakeshop Cascade', sub: 'Kendinize tatlı bir şeyler ısmarlayın', cta: 'Oyna' },
  6: { title: 'Airavat - White Elephant', sub: 'Efsanelerin ruhunu hissedin', cta: 'Oyna' },
};

function mergeItem(base, patch) {
  if (!patch) return base;
  return { ...base, ...patch };
}

function localizeList(list, map, locale) {
  if (locale !== 'tr') return list;
  return list.map((item) => mergeItem(item, map[item.id]));
}

export function localizePromo(promo, locale) {
  if (!promo || locale !== 'tr') return promo;
  const patch = PROMO_TR[promo.id] || TOURNAMENT_TR[promo.id];
  return mergeItem(promo, patch);
}

export function localizePromos(promos, locale) {
  return promos.map((p) => localizePromo(p, locale));
}

export function getBannerSlides(locale) {
  if (locale !== 'tr') return BANNER_SLIDES;
  return BANNER_SLIDES.map((slide) => {
    const key = slide.promoId || slide.ctaAction;
    return mergeItem(slide, BANNER_TR[key]);
  });
}

export function getCasinoSlides(locale) {
  if (locale !== 'tr') return CASINO_SLIDES;
  return CASINO_SLIDES.map((slide, i) => mergeItem(slide, CASINO_SLIDE_TR[i]));
}

export function getShowcaseCards(locale, t) {
  return SHOWCASE_CARDS.map((card) => ({
    ...card,
    title: locale === 'tr' ? t(`home.showcase.${card.id}.title`) : card.title,
    link: locale === 'tr' ? t(`home.showcase.${card.id}.link`) : card.link,
  }));
}

export function getPromoCategories(locale, t) {
  if (locale !== 'tr') return PROMO_CATEGORIES;
  return [t('home.promo.category.promotions'), t('home.promo.category.tournaments')];
}

export function getPromoFilters(t) {
  return [
    { id: 'all', label: t('home.promo.filter.all') },
    { id: 'casino', label: t('home.promo.filter.casino') },
    { id: 'sport', label: t('home.promo.filter.sport') },
  ];
}

export function getPromoPageFilters(t) {
  return PROMO_PAGE_FILTERS.map((f) => ({
    ...f,
    label: t(`promos.filter.${f.id}`),
  }));
}

export function getHomeCasinoCategories(t) {
  return CASINO_CATEGORIES.map((c) => t(`casino.lobby.${casinoCategoryKey(c)}`));
}

export function getHomeCasinoTabs(t, cmsTabs, lobbyKey = 'slots') {
  return casinoTabsForLobby(t, cmsTabs, lobbyKey);
}

function casinoCategoryKey(label) {
  const map = {
    Slots: 'slots',
    'Live-casino': 'live',
    'TV-games': 'tv',
    'Fast games': 'fast',
    'Virtual sports': 'virtual',
  };
  return map[label] || 'slots';
}

export function getPromos(locale) {
  return localizePromos(PROMOS, locale);
}

export function getTournamentPromos(locale) {
  return localizePromos(TOURNAMENT_PROMOS, locale);
}

export function getPromoByPromoId(promoId, locale = 'tr') {
  if (!promoId) return null;
  const all = [...getPromos(locale), ...getTournamentPromos(locale)];
  return all.find((p) => p.promoId === promoId || p.id === promoId) || null;
}

export function promoCategoryId(category, locale, t) {
  if (locale !== 'tr') {
    return category === 'Tournaments' ? 'tournaments' : 'promotions';
  }
  if (category === t('home.promo.category.tournaments')) return 'tournaments';
  return 'promotions';
}

export function isTournamentCategory(category, locale, t) {
  if (locale !== 'tr') return category === 'Tournaments';
  return category === t('home.promo.category.tournaments');
}
